/**
 * All filter components are imported here.
 */

/**
 * ! All Menus are closing after toggling their menu items.
 * TODO:
 * Review the protectedFeatures prop drilling - possibly unnecessary
 * Make the filters functional
 * Fix the toggle error
 */

import { Box, ButtonGroup, Stack, useBreakpointValue } from "@chakra-ui/react";
import DynamicSearchBar from "components/base/atoms/filters/DynamicSearchBar";

import { useGetUserProfileQuery } from "queries";
import React, { useEffect, useMemo, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  defaultJobPayload,
  defaultSavedJobPayload,
  jobPayloadState,
  savedJobPayloadState,
  savedJobsSortByState,
  selectedSortByState,
} from "_state/atoms/AppAtoms";
import AIMenu from "../base/atoms/filters/AIMenu";
import LocationMenu from "../base/atoms/filters/LocationMenu";
import PostedDate from "../base/atoms/filters/PostedDate";
import PreferenceMenu from "../base/atoms/filters/PreferenceMenu";
import SortBy from "../base/atoms/filters/SortBy";
import { OutlineButton } from "../base/atoms/HJSButton";
import { FiltersIcon, LocationPinIcon } from "../base/atoms/HJSIcons";
// import { savedJobPayloadState } from "_state/atoms/AppAtoms";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import MobileFilters from "components/base/molecules/MobileFilters";

type TJobFilter = () => JSX.Element;

const JobFilters: TJobFilter = () => {
  const isMobile: boolean = useBreakpointValue({
    base: true,
    md: false,
  }) as boolean;

  const location = useLocation();
  const isJobSearch = location.pathname === "/jobs/search";

  const [reset, setReset] = useState(false);

  const [payload, setPayload] = useRecoilState(jobPayloadState);
  const [savedJobPayload, setSavedJobPayload] =
    useRecoilState(savedJobPayloadState);

  const [selectedSortBy, setSelectedSortBy] =
    useRecoilState(selectedSortByState);
  const [savedJobsSortBy, setSavedSortBy] =
    useRecoilState(savedJobsSortByState);

  const filterMenu = useMemo(() => {
    return isJobSearch ? selectedSortBy : savedJobsSortBy;
  }, [isJobSearch, savedJobsSortBy, selectedSortBy]);

  const { data: userDetails } = useGetUserProfileQuery();

  const RenderFilterMenu = useMemo(() => {
    return filterMenu.map((el: string, idx: number) => {
      idx = -2;
      if (el?.toLowerCase().includes("location"))
        return <LocationMenu index={idx + 1} key={_.uniqueId("filter_")} />;
      if (el?.toLowerCase().includes("posted date"))
        return <PostedDate index={idx + 1} key={_.uniqueId("filter_")} />;
      if (el?.toLowerCase().includes("ai score"))
        return <AIMenu index={idx + 1} key={_.uniqueId("filter_")} />;
      if (el?.toLowerCase().includes("preference score"))
        return <PreferenceMenu index={idx + 1} key={_.uniqueId("filter_")} />;
      return null;
    });
  }, [filterMenu]);

  const handleReset = (): void => {
    setReset(true);
    // const { postedDate, ...restDefaulJobPayload } = defaultJobPayload;
    !isJobSearch && setSavedSortBy([]);
    !isJobSearch && setSavedJobPayload({ ...defaultSavedJobPayload });
  };

  useEffect(() => {
    reset && setReset(false);
  }, [payload, savedJobPayload]);

  return (
    <>
      <Stack
        direction={["column", "row"]}
        justifyContent="space-between"
        alignItems="center"
        borderRadius="6px"
        border="2px"
        borderColor="teal.600"
        minW="fit-content"
        p={{ base: 3, md: 4 }}
      >
        {isMobile ? (
          <MobileFilters />
        ) : (
          <Stack direction={["column", "row"]} alignItems="center">
            <SortBy reset={reset} setReset={setReset} />
            <ButtonGroup
              isAttached
              border="2px solid"
              borderColor="teal.600"
              backgroundColor="teal.600"
              borderRadius="xl"
              py={2}
            >
              <Box px={4} className="flex items-center">
                <FiltersIcon />
              </Box>
              {RenderFilterMenu}
            </ButtonGroup>
            <OutlineButton
              fontSize="0.8rem"
              fontWeight="700"
              onClick={() => {
                handleReset();
              }}
            >
              Reset
            </OutlineButton>
          </Stack>
        )}
        <Stack direction={["column", "row"]} justifyContent="flex-end">
          {isJobSearch && (
            <DynamicSearchBar
              Icon={<LocationPinIcon fill="none" />}
              placeholder="Enter Zip code"
              width="w-20"
              field="zipcode"
            />
          )}
          {/* <ZipMenu /> */}
          <DynamicSearchBar />
        </Stack>
      </Stack>
    </>
  );
};

export default React.memo(JobFilters);
